import {Directive, Input, ElementRef, HostListener} from '@angular/core';
import {CommonService} from '../_services/common.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[imgFallback]'
})
export class ImgFallbackDirective {
  @Input() appImgFallback: string;
  project: any = {};

  constructor(private eRef: ElementRef,
              private commonService: CommonService) {
  }

  @HostListener('error')
  loadFallbackOnError() {
    const projectType = localStorage.getItem('projectType');
    [this.project.type, this.project.logo] = this.commonService.getProjectLogo(projectType);

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
    if (this.project.type === 'yarn') {
      element.src = this.appImgFallback || '/assets/img/png/placeholder-YC.png';
    } else if (this.project.type === 'codeRed') {
      element.src = this.appImgFallback || '/assets/img/png/placeholder-CR.png';
    } else if (this.project.type === 'paint') {
      element.src = this.appImgFallback || '/assets/img/png/placeholder-PR.png';
    } else {
      element.src = this.appImgFallback || '/assets/img/png/placeholder-IC.png';
    }
  }

}
